module.exports = __webpack_public_path__ + "img/roi-and-direction.7e4e93fb.png";